import PropTypes from "prop-types";
import React from "react";
// import IconBoxData from '../../data/iconBox/icon-box.json';
// import IconBox from '../../components/IconBox/IconBox.jsx';
import SectionTitle from "../../components/SectionTitles/SectionTitle";
import NewGif from "../../components/Gif/NewGif";
// import Btn from "../../components/Btn/Btn";

const ServiceIconBox = ({ classOption }) => {
  return (
    <div className={`section section-padding-t90-b80 ${classOption}`}>
      <div className="container">
        <SectionTitle title="Anouncement" />

        <div className="conference-ind">

</div>


        <div className="row row-cols-1 mb-n6" id="anounce">
          <ul>
            <li>
              <h5>
              <div className="font-red">
              <NewGif />{" "}
              <a href="http://www.iasei.org/icsi2023">
              Welcome to join ICSI&apos;2023 in Shenzhen, China, July 14th-18th, 2023!
              </a>
              {/* ICSI&apos;2022 is ready for all authors and participants, welcome to our exciting conference ICSI&apos;2022! */}
              </div>
              </h5>
            </li>
            <br></br>
            <br></br>
            <li>
              <h5>
              <div>
              {/* <NewGif />{" "} */}
              <a href="./gallery">
              Congratulations! ICSI&apos;2022 has been held successfully on 15th - 19th, July.
              </a>
              {/* ICSI&apos;2022 is ready for all authors and participants, welcome to our exciting conference ICSI&apos;2022! */}
              </div>
              </h5>
            </li>
            <li>
              <h5>
              {/* <NewGif />{" "} */}
              <a href="./gallery">
              <div>
              Our wonderful moments!
              </div>
              </a>
              </h5>
            </li>
            <li>
              <h5>
              {/* <NewGif />{" "} */}
              <a href="./files/ICSI2022-Program.pdf">
              <div>
              The Final Program Booklet of ICSI&apos;2022 is ready for download!
              </div>
              </a>
              </h5>
            </li>
            {/* <li>
              <div className="vertical_center">
                <div >
                </div>
              <h5>
              <a href="./proceeding">
              The ICSI&apos;2022 Proceedings (Springer-Nature LNCS 13344 and LNCS 13345) are available online for all participants 
              <br></br>
              to download, for free, from July 08, 2022 to August 08, 2022!
              </a>
              </h5>
              </div>
            </li> */}
            <li>
              <h5>
              {/* <NewGif />{" "} */}
              <a href="./program">
              <div>
              The scheduled timetables of ICSI&apos;2022 presentations have been made for all participants!
              </div>
              </a>
              </h5>
            </li>
            <li>
              <h5>
              {/* <NewGif />{" "} */}
              <a href="./competition_result">
              <div>
              The FINAL results of ICSI-OC&apos;2022 have been announced online!
              </div>
              </a>
              </h5>
            </li>

            <div className="space-40"></div>
            <li>
              <h5>
                <a href="./competition">
                  <del>

                ICSI-OC&apos;2022: &quot; Competition on Single Objective
                Bounded Optimization Problems&quot; call for participants!
                  </del>
                </a>
                </h5>
              </li>

            {/* <li>
              <h5>
              <NewGif />{" "}
              <p></p>
              </h5>
            </li> */}

            <li>
              <h5>
                <p href="./registration">
                  <del>
                    Registration is open! Paper registration deadline: April 30.{" "}
                  </del>
                </p>
              </h5>
            </li>

            <li>
              <h5>
                <del>
                  The notification letters for ICSI&apos;2022 submissions have
                  been sent to the corresponding author(s) of each
                  ICSI&apos;2022 <br />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;submission on April 15, 2022.
                </del>
              </h5>
            </li>
            <li>
              <h5>
              <a href="./submission">
              <del>
              ICSI&apos;2022 call for papers!
              </del>
              </a>
              </h5>
            </li>
            {/* <li>
              <h5>
              <NewGif />{" "}
              <a href="./submission_zn">
              ICSI&apos;2022 Chinese Track call for papers!
              </a>
              </h5>
              </li>
              <li>
              <h5><NewGif/> <a href="./special-session">ICSI 2022 Call for special sessions! </a></h5>
            </li> */}
            <li>
              <h5>
                <a href="./special-session#session1">
                  <del>
                    Special Session 1: &quot;Swarm Intelligence and Machine
                    Learning in Management Science and Industrial
                    Applications&quot;{" "}
                  </del>
                </a>
              </h5>
            </li>
            <li>
              <h5>
                <a href="./special-session#session2">
                  <del>
                    Special Session 2: &quot;Brain Storm Optimization Algorithm
                    and Its Applications&quot;{" "}
                  </del>
                </a>
              </h5>
            </li>
          </ul>
        </div>
        {/* <div>
        Notice: 
        Due to the rapid overspreading of Omicron variant of COVID-19, even though the ICSI 2022 was planned to be held in a hybrid mode, after carefully evaluating most of announcements and guidance regarding to COVID-19, and too much restrictions on traveling to the venue, released by relevant national departments and Xi&apos;an municipal, the ICSI 2022 organizing committee has made the decision that our ICSI 2022 will continue as scheduled on July 15-19, by being converted to a fully virtual conference. The ICSI 2022 technical team will be providing the ability for the authors with accepted papers to present their work through an interactive online platform or video replay. The presentations of accepted authors will be made available to all registered attendees online.
        </div> */}
        <div className="conference-ind">

<div className="online-info" >
 Notice: 
Due to the rapid overspreading of Omicron variant of COVID-19, even though the ICSI 2022 was planned to be held in a hybrid mode, after carefully evaluating most of announcements and guidance regarding to COVID-19, and too much restrictions on traveling to the venue, released by relevant national departments and Xi&apos;an municipal, the ICSI 2022 organizing committee has made the decision that our ICSI 2022 will continue as scheduled on July 15-19, by being converted to a fully virtual conference. The ICSI 2022 technical team will be providing the ability for the authors with accepted papers to present their work through an interactive online platform or video replay. The presentations of accepted authors will be made available to all registered attendees online.
</div>
</div>
        {/* <div className="double-sub">
          <Btn
          name="Submit English paper"
          linkage={process.env.PUBLIC_URL + "/submission"}
          />
          <div className="space"></div>
          <Btn
            name="Submit Chinese paper"
            linkage={process.env.PUBLIC_URL + "/submission_zn"}
          />
        </div> */}
      </div>
    </div>
  );
};

ServiceIconBox.propTypes = {
  classOption: PropTypes.string,
};
ServiceIconBox.defaultProps = {
  classOption: "section section-padding-t90-b100",
};

export default ServiceIconBox;
